import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

import pedidosModule from './modules/pedidos'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialogMain: {
      dialog: false,
      type: ''
    },
    dialogSecoundMain: {
      dialog: false,
      type: '',
      showtype: ''
    },
    urls: null,
    objects: [],
    objectsSecound: [],
    objectsExport: null,
    object: {},
    objectSecound: {},
    objectThird: {},
    objectsThird: [],
    objectPagination: {},
    logout: {}
  },
  getters: {
    get_pizzas (state) {
      return state.pizzas
    },
    get_dialogMain (state) {
      return state.dialogMain
    },
    get_dialogSecoundMain (state) {
      return state.dialogSecoundMain
    },
    get_urls (state) {
      return state.urls
    },
    get_objects (state) {
      return state.objects
    },
    get_objectsSecound (state) {
      return state.objectsSecound
    },
    get_objectsThird (state) {
      return state.objectsThird
    },
    get_object (state) {
      return state.object
    },
    get_objectSecound (state) {
      return state.objectSecound
    },
    get_objectThird (state) {
      return state.objectThird
    },
    get_objectsExport (state) {
      return state.objectsExport
    },
    get_objectPagination (state) {
      return state.objectPagination
    },
    get_logout (state) {
      return state.logout
    }
  },
  mutations: {
    SHOW_DIALOG_MAIN (state, data) {
      state.dialogMain.dialog = true
      state.dialogMain.type = data.type
    },
    HIDDE_DIALOG_MAIN (state) {
      state.dialogMain.dialog = false
      state.dialogMain.type = ''
    },
    SHOW_DIALOG_SECOUND_MAIN (state, data) {
      state.dialogSecoundMain.dialog = true
      state.dialogSecoundMain.type = data.type
      if (data.showtype) {
        state.dialogSecoundMain.showtype = data.showtype
      }
    },
    HIDDE_DIALOG_SECOUND_MAIN (state) {
      state.dialogSecoundMain.dialog = false
      state.dialogSecoundMain.type = ''
      state.dialogSecoundMain.showtype = ''
    },

    // Setters Data
    SET_DATA_MAIN (state, data) {
      state.objects.push(data)
    },
    SET_DATA_SECOUND_MAIN (state, data) {
      state.objectSecound = data
    },
    GET_DATA_SERVER_THIRD (state, user) {
      state.objectThird = user
    },
    SET_DATA_USER (state, user) {
      state.objects.push(user)
    },
    SET_DATA_ENCUESTA (state, encuesta) {
      state.objects.push(encuesta)
    },

    CLEAR_DATAS_MAIN (state) {
      state.objects = []
    },
    CLEAR_DATA_MAIN (state) {
      state.object = {}
    },
    GET_URLS_SERVER (state, urls) {
      state.urls = {}
      state.urls = urls
    },
    GET_DATA_SERVER (state, data) {
      state.object = {}
      state.object = data
    },
    GET_DATA_SERVER_EXPORT_LIST (state, data) {
      state.objectsExport = {}
      state.objectsExport = data
    },
    GET_DATA_SERVER_LIST (state, data) {
      state.objects = []
      state.objects.push(...data)
    },
    GET_DATA_SERVER_LIST_SECOUND (state, data) {
      state.objectsSecound = []
      state.objectsSecound.push(...data)
    },
    GET_DATA_SERVER_LIST_THIRD (state, data) {
      state.objectsThird = []
      state.objectsThird.push(...data)
    },
    POST_DATA_SERVER (state, data) {
      state.object = {}
      state.object = data
    },
    POST_DATA_PAGINATION_SERVER (state, data) {
      state.objectPagination = {}
      state.objectPagination = data
    },

    GET_LOGOUT (state, data) {
      state.logout = {}
      state.logout = data
    }
  },
  actions: {
    getUrlServices ({ commit }) {
      axios.post('/app/rutas').then(response => {
        commit('GET_URLS_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    getUrlServicesAction ({ commit }, url) {
      const token = Vue.$cookies.get('token')
      // const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMmQ4NGY1YmVlZDBjZDMzZDI1ZmU3ZDI2N2RjODYwNzA3MGQxZTZiMzI5YTM4ODRmYmIyYTFmZjBiMGJiM2UxYmFhODBiM2IyZTVkN2EwZTgiLCJpYXQiOjE2MTg1MDU3NzMsIm5iZiI6MTYxODUwNTc3MywiZXhwIjoxNjUwMDQxNzczLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.dUNAIIn_R0ttfkiC4KMf54nRx4rs_on1llkeaFv1Kk4xfW59A3q_uGzSxkqa2s379YcWGmqrJBR0N7FTqlqk6H6BDoG7izgVIGTsEhxcc8olWyN7JQTx7Hn-aZqmigTDgsLRByQ7siGxSpp3sNAwu_uHIiiI9FuiciJalkRVxib0jonewUQMB_ehV8IvT0lGC5Q51B1wKEm6RCmwzDvqXmE37rNjoQGcwJjMpbUmOLk-o-b0I1lazPt57OFzKjzV39njs52HlrLR-jIDoTR2CTXhBqVNH75xanI6rXcrrDpknOEy_vLued_f7cSrW8hPYAoL3jVnBhyAQrAThtRGjkwOBWJ7Bp8KPII5tLX_9STzI0zrLZqdhIyA83rcV9z3f_EE-PAfVkfGQo4XMsEw8B3AwI_5jzeh4of3ciXOq4XPmU4iTskfStjSlDork4cd3qMPdteWxKGQscNYcz806wX14iRn86AeielIyldxFlseJQeZ3u6LTZjFTLXpOrFFAcO98y4yxmBDAl0RmkKnsHBHUwjMLmdWoYif2xE3XqKTB_cegG_dTsgaWvn3jCZaEA1vsmLzYDfO9vmoy0AvaV6MWm7NNICNfdMpuUewS2K5QKIChRMA6kO4Ea3H8rJpTEOiymGHyuoWgrSeaecy0p-_a0_iSLzhrN8bnoLGlt0'
      axios.get(`${url}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('GET_DATA_SERVER_LIST', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    getUrlServicesSecoundAction ({ commit }, url) {
      // console.log('url', url)
      const token = Vue.$cookies.get('token')
      // const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMmQ4NGY1YmVlZDBjZDMzZDI1ZmU3ZDI2N2RjODYwNzA3MGQxZTZiMzI5YTM4ODRmYmIyYTFmZjBiMGJiM2UxYmFhODBiM2IyZTVkN2EwZTgiLCJpYXQiOjE2MTg1MDU3NzMsIm5iZiI6MTYxODUwNTc3MywiZXhwIjoxNjUwMDQxNzczLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.dUNAIIn_R0ttfkiC4KMf54nRx4rs_on1llkeaFv1Kk4xfW59A3q_uGzSxkqa2s379YcWGmqrJBR0N7FTqlqk6H6BDoG7izgVIGTsEhxcc8olWyN7JQTx7Hn-aZqmigTDgsLRByQ7siGxSpp3sNAwu_uHIiiI9FuiciJalkRVxib0jonewUQMB_ehV8IvT0lGC5Q51B1wKEm6RCmwzDvqXmE37rNjoQGcwJjMpbUmOLk-o-b0I1lazPt57OFzKjzV39njs52HlrLR-jIDoTR2CTXhBqVNH75xanI6rXcrrDpknOEy_vLued_f7cSrW8hPYAoL3jVnBhyAQrAThtRGjkwOBWJ7Bp8KPII5tLX_9STzI0zrLZqdhIyA83rcV9z3f_EE-PAfVkfGQo4XMsEw8B3AwI_5jzeh4of3ciXOq4XPmU4iTskfStjSlDork4cd3qMPdteWxKGQscNYcz806wX14iRn86AeielIyldxFlseJQeZ3u6LTZjFTLXpOrFFAcO98y4yxmBDAl0RmkKnsHBHUwjMLmdWoYif2xE3XqKTB_cegG_dTsgaWvn3jCZaEA1vsmLzYDfO9vmoy0AvaV6MWm7NNICNfdMpuUewS2K5QKIChRMA6kO4Ea3H8rJpTEOiymGHyuoWgrSeaecy0p-_a0_iSLzhrN8bnoLGlt0'
      axios.get(`${url}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('SET_DATA_SECOUND_MAIN', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    getUrlServiceAction ({ commit }, url) {
      const token = Vue.$cookies.get('token')
      // const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMmQ4NGY1YmVlZDBjZDMzZDI1ZmU3ZDI2N2RjODYwNzA3MGQxZTZiMzI5YTM4ODRmYmIyYTFmZjBiMGJiM2UxYmFhODBiM2IyZTVkN2EwZTgiLCJpYXQiOjE2MTg1MDU3NzMsIm5iZiI6MTYxODUwNTc3MywiZXhwIjoxNjUwMDQxNzczLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.dUNAIIn_R0ttfkiC4KMf54nRx4rs_on1llkeaFv1Kk4xfW59A3q_uGzSxkqa2s379YcWGmqrJBR0N7FTqlqk6H6BDoG7izgVIGTsEhxcc8olWyN7JQTx7Hn-aZqmigTDgsLRByQ7siGxSpp3sNAwu_uHIiiI9FuiciJalkRVxib0jonewUQMB_ehV8IvT0lGC5Q51B1wKEm6RCmwzDvqXmE37rNjoQGcwJjMpbUmOLk-o-b0I1lazPt57OFzKjzV39njs52HlrLR-jIDoTR2CTXhBqVNH75xanI6rXcrrDpknOEy_vLued_f7cSrW8hPYAoL3jVnBhyAQrAThtRGjkwOBWJ7Bp8KPII5tLX_9STzI0zrLZqdhIyA83rcV9z3f_EE-PAfVkfGQo4XMsEw8B3AwI_5jzeh4of3ciXOq4XPmU4iTskfStjSlDork4cd3qMPdteWxKGQscNYcz806wX14iRn86AeielIyldxFlseJQeZ3u6LTZjFTLXpOrFFAcO98y4yxmBDAl0RmkKnsHBHUwjMLmdWoYif2xE3XqKTB_cegG_dTsgaWvn3jCZaEA1vsmLzYDfO9vmoy0AvaV6MWm7NNICNfdMpuUewS2K5QKIChRMA6kO4Ea3H8rJpTEOiymGHyuoWgrSeaecy0p-_a0_iSLzhrN8bnoLGlt0'
      axios.get(`${url}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('GET_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    getUrlServicesExportAction ({ commit }, url) {
      const token = Vue.$cookies.get('token')
      // const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMmQ4NGY1YmVlZDBjZDMzZDI1ZmU3ZDI2N2RjODYwNzA3MGQxZTZiMzI5YTM4ODRmYmIyYTFmZjBiMGJiM2UxYmFhODBiM2IyZTVkN2EwZTgiLCJpYXQiOjE2MTg1MDU3NzMsIm5iZiI6MTYxODUwNTc3MywiZXhwIjoxNjUwMDQxNzczLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.dUNAIIn_R0ttfkiC4KMf54nRx4rs_on1llkeaFv1Kk4xfW59A3q_uGzSxkqa2s379YcWGmqrJBR0N7FTqlqk6H6BDoG7izgVIGTsEhxcc8olWyN7JQTx7Hn-aZqmigTDgsLRByQ7siGxSpp3sNAwu_uHIiiI9FuiciJalkRVxib0jonewUQMB_ehV8IvT0lGC5Q51B1wKEm6RCmwzDvqXmE37rNjoQGcwJjMpbUmOLk-o-b0I1lazPt57OFzKjzV39njs52HlrLR-jIDoTR2CTXhBqVNH75xanI6rXcrrDpknOEy_vLued_f7cSrW8hPYAoL3jVnBhyAQrAThtRGjkwOBWJ7Bp8KPII5tLX_9STzI0zrLZqdhIyA83rcV9z3f_EE-PAfVkfGQo4XMsEw8B3AwI_5jzeh4of3ciXOq4XPmU4iTskfStjSlDork4cd3qMPdteWxKGQscNYcz806wX14iRn86AeielIyldxFlseJQeZ3u6LTZjFTLXpOrFFAcO98y4yxmBDAl0RmkKnsHBHUwjMLmdWoYif2xE3XqKTB_cegG_dTsgaWvn3jCZaEA1vsmLzYDfO9vmoy0AvaV6MWm7NNICNfdMpuUewS2K5QKIChRMA6kO4Ea3H8rJpTEOiymGHyuoWgrSeaecy0p-_a0_iSLzhrN8bnoLGlt0'
      axios.get(`${url}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        console.log('response', response.data)
        commit('GET_DATA_SERVER_EXPORT_LIST', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postUrlServicesListAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, (action.data) ? action.data : {}, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('GET_DATA_SERVER_LIST', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postUrlServicesAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      // const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMmQ4NGY1YmVlZDBjZDMzZDI1ZmU3ZDI2N2RjODYwNzA3MGQxZTZiMzI5YTM4ODRmYmIyYTFmZjBiMGJiM2UxYmFhODBiM2IyZTVkN2EwZTgiLCJpYXQiOjE2MTg1MDU3NzMsIm5iZiI6MTYxODUwNTc3MywiZXhwIjoxNjUwMDQxNzczLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.dUNAIIn_R0ttfkiC4KMf54nRx4rs_on1llkeaFv1Kk4xfW59A3q_uGzSxkqa2s379YcWGmqrJBR0N7FTqlqk6H6BDoG7izgVIGTsEhxcc8olWyN7JQTx7Hn-aZqmigTDgsLRByQ7siGxSpp3sNAwu_uHIiiI9FuiciJalkRVxib0jonewUQMB_ehV8IvT0lGC5Q51B1wKEm6RCmwzDvqXmE37rNjoQGcwJjMpbUmOLk-o-b0I1lazPt57OFzKjzV39njs52HlrLR-jIDoTR2CTXhBqVNH75xanI6rXcrrDpknOEy_vLued_f7cSrW8hPYAoL3jVnBhyAQrAThtRGjkwOBWJ7Bp8KPII5tLX_9STzI0zrLZqdhIyA83rcV9z3f_EE-PAfVkfGQo4XMsEw8B3AwI_5jzeh4of3ciXOq4XPmU4iTskfStjSlDork4cd3qMPdteWxKGQscNYcz806wX14iRn86AeielIyldxFlseJQeZ3u6LTZjFTLXpOrFFAcO98y4yxmBDAl0RmkKnsHBHUwjMLmdWoYif2xE3XqKTB_cegG_dTsgaWvn3jCZaEA1vsmLzYDfO9vmoy0AvaV6MWm7NNICNfdMpuUewS2K5QKIChRMA6kO4Ea3H8rJpTEOiymGHyuoWgrSeaecy0p-_a0_iSLzhrN8bnoLGlt0'
      axios.post(`${action.url}`, action.data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        commit('POST_DATA_SERVER', response.data)
      }).catch(error => {
        if (error.code === 'ECONNABORTED') {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'TimeOut !!'
          })
        } else if (error == null) {
          Vue.swal({
            type: 'error',
            title: 'Ooops!',
            text: 'Problemas con el servidor, contactar al sistemas !!'
          })
        }
      })
    },

    postUrlServicesPaginationAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, action.data, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('POST_DATA_PAGINATION_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    // Secound Object
    postUrlServicesListActionSecound ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, (action.data) ? action.data : {}, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('GET_DATA_SERVER_LIST_SECOUND', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postUrlServiceActionSecound ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.post(`${action.url}`, (action.data) ? action.data : {}, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('SET_DATA_SECOUND_MAIN', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    // Third Object
    getUrlServiceThirdAction ({ commit }, url) {
      const token = Vue.$cookies.get('token')
      // const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMmQ4NGY1YmVlZDBjZDMzZDI1ZmU3ZDI2N2RjODYwNzA3MGQxZTZiMzI5YTM4ODRmYmIyYTFmZjBiMGJiM2UxYmFhODBiM2IyZTVkN2EwZTgiLCJpYXQiOjE2MTg1MDU3NzMsIm5iZiI6MTYxODUwNTc3MywiZXhwIjoxNjUwMDQxNzczLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.dUNAIIn_R0ttfkiC4KMf54nRx4rs_on1llkeaFv1Kk4xfW59A3q_uGzSxkqa2s379YcWGmqrJBR0N7FTqlqk6H6BDoG7izgVIGTsEhxcc8olWyN7JQTx7Hn-aZqmigTDgsLRByQ7siGxSpp3sNAwu_uHIiiI9FuiciJalkRVxib0jonewUQMB_ehV8IvT0lGC5Q51B1wKEm6RCmwzDvqXmE37rNjoQGcwJjMpbUmOLk-o-b0I1lazPt57OFzKjzV39njs52HlrLR-jIDoTR2CTXhBqVNH75xanI6rXcrrDpknOEy_vLued_f7cSrW8hPYAoL3jVnBhyAQrAThtRGjkwOBWJ7Bp8KPII5tLX_9STzI0zrLZqdhIyA83rcV9z3f_EE-PAfVkfGQo4XMsEw8B3AwI_5jzeh4of3ciXOq4XPmU4iTskfStjSlDork4cd3qMPdteWxKGQscNYcz806wX14iRn86AeielIyldxFlseJQeZ3u6LTZjFTLXpOrFFAcO98y4yxmBDAl0RmkKnsHBHUwjMLmdWoYif2xE3XqKTB_cegG_dTsgaWvn3jCZaEA1vsmLzYDfO9vmoy0AvaV6MWm7NNICNfdMpuUewS2K5QKIChRMA6kO4Ea3H8rJpTEOiymGHyuoWgrSeaecy0p-_a0_iSLzhrN8bnoLGlt0'
      axios.post(`${url.url}`, (url.data) ? url.data : {}, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('GET_DATA_SERVER_THIRD', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    getUrlServicesThirdAction ({ commit }, url) {
      const token = Vue.$cookies.get('token')
      // const token = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMmQ4NGY1YmVlZDBjZDMzZDI1ZmU3ZDI2N2RjODYwNzA3MGQxZTZiMzI5YTM4ODRmYmIyYTFmZjBiMGJiM2UxYmFhODBiM2IyZTVkN2EwZTgiLCJpYXQiOjE2MTg1MDU3NzMsIm5iZiI6MTYxODUwNTc3MywiZXhwIjoxNjUwMDQxNzczLCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.dUNAIIn_R0ttfkiC4KMf54nRx4rs_on1llkeaFv1Kk4xfW59A3q_uGzSxkqa2s379YcWGmqrJBR0N7FTqlqk6H6BDoG7izgVIGTsEhxcc8olWyN7JQTx7Hn-aZqmigTDgsLRByQ7siGxSpp3sNAwu_uHIiiI9FuiciJalkRVxib0jonewUQMB_ehV8IvT0lGC5Q51B1wKEm6RCmwzDvqXmE37rNjoQGcwJjMpbUmOLk-o-b0I1lazPt57OFzKjzV39njs52HlrLR-jIDoTR2CTXhBqVNH75xanI6rXcrrDpknOEy_vLued_f7cSrW8hPYAoL3jVnBhyAQrAThtRGjkwOBWJ7Bp8KPII5tLX_9STzI0zrLZqdhIyA83rcV9z3f_EE-PAfVkfGQo4XMsEw8B3AwI_5jzeh4of3ciXOq4XPmU4iTskfStjSlDork4cd3qMPdteWxKGQscNYcz806wX14iRn86AeielIyldxFlseJQeZ3u6LTZjFTLXpOrFFAcO98y4yxmBDAl0RmkKnsHBHUwjMLmdWoYif2xE3XqKTB_cegG_dTsgaWvn3jCZaEA1vsmLzYDfO9vmoy0AvaV6MWm7NNICNfdMpuUewS2K5QKIChRMA6kO4Ea3H8rJpTEOiymGHyuoWgrSeaecy0p-_a0_iSLzhrN8bnoLGlt0'
      axios.get(`${url}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        // console.log('response', response.data)
        commit('GET_DATA_SERVER_LIST_THIRD', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },

    //
    postUrlServiceLoginAction ({ commit }, action) {
      axios.post(`${action.url}`, action.data).then(response => {
        commit('POST_DATA_SERVER', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    getUrlServiceLogoutAction ({ commit }, action) {
      const token = Vue.$cookies.get('token')
      axios.get(`${action}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        commit('GET_LOGOUT', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    }
  },
  modules: {
    pedidosModule
  }
})
